module.exports = __webpack_public_path__ + "f478ad0dc233b132a5b662f58b8e674b.mp4";